class ScrollMonitor {
  constructor (isScrollOngoingCallback) {
    this.isScrollOngoingCallback = isScrollOngoingCallback
    this.isScrollOngoingTimeout = null
    this.lastScrollPosition = null
    this.prevScrolledDistance = null
    this.prePrevScrolledDistance = null
  }

  handleScrollStop = () => {
    this.lastScrollPosition = null
    if (typeof this.isScrollOngoingCallback === 'function') {
      this.isScrollOngoingCallback(false)
    }
  }

  isScrollOngoing = () => {
    const currentScrollPosition = window.scrollY
    let currentScrolledDistance = 0
    if (this.lastScrollPosition != null) {
      currentScrolledDistance = Math.abs(currentScrollPosition - this.lastScrollPosition)
    }
    this.lastScrollPosition = currentScrollPosition
    clearTimeout(this.isScrollOngoingTimeout)
    this.isScrollOngoingTimeout = setTimeout(this.handleScrollStop, 200)

    const isScrollOngoing = currentScrolledDistance >= 20

    // we have to check how scrolled distance changed comparing two previous distances to
    // catch anomalies caused by `isScrollOngoing` call delays
    const scrolledDistanceChange = Math.abs(this.prevScrolledDistance - currentScrolledDistance)
    const prevScrolledDistanceChange = Math.abs(this.prePrevScrolledDistance - currentScrolledDistance)
    const wasScrollOngoing = scrolledDistanceChange >= 5 || prevScrolledDistanceChange >= 5

    this.prePrevScrolledDistance = this.prevScrolledDistance
    this.prevScrolledDistance = currentScrolledDistance

    if (typeof this.isScrollOngoingCallback === 'function') {
      this.isScrollOngoingCallback(isScrollOngoing || wasScrollOngoing)
    }
  }
}

export default ScrollMonitor
